module.exports = __webpack_public_path__ + "img/6-5.c96f2be7.png";